// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1K8yD","tab":"Tabs_tab__3SgOM","tabActive":"Tabs_tabActive__OiiY9"};